import type { ProductModel } from '@/engines/product-intelligence'

/** Unified Comparison Engine — domain types (Sprint 2.2) */

export type SupplierChannel = 'distributor' | 'web' | 'paraguay'

export type ComparisonSortMode =
  | 'price_asc'
  | 'stock_desc'
  | 'delivery_asc'
  | 'margin_desc'
  | 'preferred'
  | 'availability'

export interface ComparisonOfferInput {
  offerId: string
  fingerprint: string
  product: ProductModel
  supplierId: string
  supplierName: string
  channel: SupplierChannel
  price: number
  currency: 'BRL' | 'USD'
  stock: number
  deliveryDays: number
  updatedAt: string
  marginPercent?: number
  purchasePrice?: number
}

export interface ComparisonOffer extends ComparisonOfferInput {
  isBestPrice: boolean
  isBestStock: boolean
  isBestDelivery: boolean
  isBestMargin: boolean
  priceDiffFromBest: number
  priceDiffPercent: number
}

export interface ComparisonRow {
  fingerprint: string
  product: ProductModel
  label: string
  offers: ComparisonOffer[]
  bestPrice: number | null
  worstPrice: number | null
  economy: number
  economyPercent: number
  bestStock: number
  bestDelivery: number | null
  bestMargin: number | null
  recommendedSupplier: string | null
  supplierCount: number
}

export interface ComparisonSummary {
  rowCount: number
  offerCount: number
  bestPrice: number | null
  totalEconomy: number
  recommendedSupplier: string | null
  selectedCount: number
  selectedTotal: number
  estimatedMargin: number | null
}

export interface ComparisonFiltersState {
  query: string
  distributorsOnly: boolean
  webOnly: boolean
  paraguayOnly: boolean
  inStockOnly: boolean
  showOutOfStock: boolean
  hideDuplicates: boolean
}

export interface ComparisonPreferences {
  preferredProvider: string | null
  sortMode: ComparisonSortMode
  favoriteSuppliers: string[]
}

export interface ComparisonPriceHistoryEntry {
  id: string
  productId: string
  fingerprint: string
  provider: string
  price: number
  stock: number
  delivery: number
  createdAt: string
}

export interface ComparisonBuildResult {
  rows: ComparisonRow[]
  summary: ComparisonSummary
  suppliers: string[]
}

export const DEFAULT_COMPARISON_FILTERS: ComparisonFiltersState = {
  query: '',
  distributorsOnly: false,
  webOnly: false,
  paraguayOnly: false,
  inStockOnly: false,
  showOutOfStock: true,
  hideDuplicates: true,
}

export const DEFAULT_COMPARISON_PREFERENCES: ComparisonPreferences = {
  preferredProvider: null,
  sortMode: 'price_asc',
  favoriteSuppliers: [],
}
